// @ts-check

// Vendor imports
const _ = require('lodash')

/** @type {Object.<string, number>} */
const keyCodesByName = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shiftLeft: 16,
  shiftRight: 16,
  ctrlLeft: 17,
  ctrlRight: 17,
  altLeft: 18,
  altRight: 18,
  pause: 19,
  capsLock: 20,
  escape: 27,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  insert: 45,
  delete: 46,
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  metaLeft: 91,
  metaRight: 92,
  select: 93,
  numpad0: 96,
  numpad1: 97,
  numpad2: 98,
  numpad3: 99,
  numpad4: 100,
  numpad5: 101,
  numpad6: 102,
  numpad7: 103,
  numpad8: 104,
  numpad9: 105,
  numpadMultiply: 106,
  numpadAdd: 107,
  numpadSubtract: 109,
  numpadDecimal: 110,
  numpadDivide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numLock: 144,
  scrollLock: 145,
  semicolon: 186,
  equal: 187,
  comma: 188,
  minus: 189,
  period: 190,
  slash: 191,
  backquote: 192,
  bracketLeft: 219,
  backslash: 220,
  braketRight: 221,
  quote: 222
}

/** @type {Object.<number, string>} */
const keyNamesByCode = _.invert(keyCodesByName)

/**
 * @param {string} keyName
 * @returns {number}
 */
function getKeyCodeForName(keyName) {
  return keyCodesByName[keyName]
}

/**
 * @param {number} keyCode
 * @returns {string}
 */
function getKeyNameForCode(keyCode) {
  return keyNamesByCode[keyCode]
}

/**
 * @param {Event} event
 */
function preventDefault(event) {
  event.preventDefault()
  event.stopPropagation()
}

/**
 * @param {Event} event
 */
function stopPropagation(event) {
  event.stopPropagation()
}

/**
 * @param {function} callback
 * @param {object} options
 */
function eventHandler(callback, options) {
  return (/** @type {Event} */ event) => {
    event.preventDefault()
    event.stopPropagation()
    callback({ ...options, event })
  }
}

module.exports = {
  eventHandler,
  getKeyNameForCode,
  getKeyCodeForName,
  keyCodesByName,
  keyNamesByCode,
  preventDefault,
  stopPropagation
}
